import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useLanguage } from "@/contexts/LanguageContext";
import type { PostMeta } from "@/lib/posts";
interface PostCardProps {
  post: PostMeta;
}
export default function PostCard(t0) {
  const $ = _c(40);
  const {
    post
  } = t0;
  const {
    t
  } = useLanguage();
  let t1;
  if ($[0] !== post.date) {
    t1 = new Date(`${post.date}T00:00:00`).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
    $[0] = post.date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  const t2 = `/posts/${post.slug}/`;
  let t3;
  if ($[2] !== post.coverImage || $[3] !== post.title) {
    t3 = <Image src={post.coverImage} alt={post.title} fill={true} className="object-cover transition-transform group-hover:scale-105" sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" />;
    $[2] = post.coverImage;
    $[3] = post.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== post.language) {
    t4 = post.language.toUpperCase();
    $[5] = post.language;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="absolute top-3 right-3 rounded-full bg-surface/80 px-2.5 py-0.5 text-xs font-bold uppercase text-text-primary backdrop-blur-sm">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="relative aspect-video overflow-hidden">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== post.tags) {
    t7 = post.tags.map(_temp);
    $[12] = post.tags;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="mb-3 flex flex-wrap gap-2">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== post.title) {
    t9 = <h3 className="mb-2 text-lg font-bold text-text-primary group-hover:text-brand-primary transition-colors line-clamp-2">{post.title}</h3>;
    $[16] = post.title;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== post.excerpt) {
    t10 = <p className="mb-4 text-sm text-text-secondary line-clamp-3">{post.excerpt}</p>;
    $[18] = post.excerpt;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== formattedDate || $[21] !== post.date) {
    t11 = <time dateTime={post.date}>{formattedDate}</time>;
    $[20] = formattedDate;
    $[21] = post.date;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = post.readingTime;
  let t13;
  if ($[23] !== t) {
    t13 = t("posts.minRead");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== post.readingTime || $[26] !== t13) {
    t14 = <span>{t12} {t13}</span>;
    $[25] = post.readingTime;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14) {
    t15 = <div className="flex items-center justify-between text-xs text-text-muted">{t11}{t14}</div>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t15 || $[33] !== t8 || $[34] !== t9) {
    t16 = <div className="p-5">{t8}{t9}{t10}{t15}</div>;
    $[31] = t10;
    $[32] = t15;
    $[33] = t8;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16 || $[37] !== t2 || $[38] !== t6) {
    t17 = <article className="group overflow-hidden rounded-xl border border-border-default bg-surface-card transition-all hover:border-border-hover hover:shadow-lg"><Link href={t2} className="block">{t6}{t16}</Link></article>;
    $[36] = t16;
    $[37] = t2;
    $[38] = t6;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp(tag) {
  return <span key={tag} className="rounded-full bg-brand-primary/10 px-2.5 py-0.5 text-xs font-medium text-brand-primary">{tag}</span>;
}